import React from "react";
import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import "react-toastify/dist/ReactToastify.css";

import { toast } from "react-toastify";

const SUCCESE = async (data: any) => {
  toast.success(data, {
    position: toast.POSITION.TOP_LEFT,
  });
};
const FAILED = async (data: any) => {
  console.log(data);
  toast.error(data.message, {
    position: toast.POSITION.TOP_LEFT,
  });
};

export const onboardingEditBasicInfo: any = createSlice({
  name: "onboardingEditBasicInfo",
  initialState: {
    data: [],
    isCompleted: false,
    isLoading: false,
  },
  reducers: {
    raise_api_call_edit_basic_info: (state, action?: any) => {
      state.isLoading = true;
    },
    success_api_call_edit_basic_info: (state, action) => {
      state.data = action.payload;
      state.isLoading = false;
    },
    failure_api_call_edit_basic_info: (state, action) => {
      state.isLoading = false;
      FAILED(action.payload);
    },
    edit_basic_complete: (state, action) => {
      state.isLoading = false;
    },
    edit_basic_info_loading_complete: (state, action) => {
      state.isLoading = false;
    },
  },
});
export default onboardingEditBasicInfo.reducer;
export const {
  raise_api_call_edit_basic_info,
  success_api_call_edit_basic_info,
  failure_api_call_edit_basic_info,
  edit_basic_info_loading_complete,
} = onboardingEditBasicInfo.actions;
